import { render, staticRenderFns } from "./ServiceFeeList.vue?vue&type=template&id=f1425bfa&"
import script from "./ServiceFeeList.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeList.vue?vue&type=style&index=0&id=f1425bfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports